import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  query,
  style,
  stagger,
  animate,
  keyframes,
} from '@angular/animations';
import { Document } from '../../../interfaces/graph-types';
import { Subject } from 'rxjs';
import { WatchAccountService } from '../../../services/watch-account.service';
import { LiveFeedService } from '../../../services/live-feed.service';

@Component({
  selector: '[account-live-feed]',
  template: require('./account-live-feed.component.pug'),
  styles: [require('./account-live-feed.component.css').toString()],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class AccountLiveFeedComponent implements OnInit {
  img_empty = require('../dashboard/empty.png').default;

  candidateSubjectId: Subject<string>;

  sub: any = null;
  feed: any = null;
  loading: boolean = true;

  // -------------------------------------------------------------------
  constructor(
    private feedService: LiveFeedService,
    private watch: WatchAccountService,
  ) {
    this.candidateSubjectId = new Subject<string>();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.feedService.eventEntries$.subscribe(events => {
      this.loading = false;
      this.feed = events;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.watch.accountId().getValue();
  }

  viewingCandidate: string;
  // -------------------------------------------------------------------
  selectCandidateInfo(candidateId) {
    this.viewingCandidate = candidateId;
    this.candidateSubjectId.next(candidateId);
  }

  // -------------------------------------------------------------------
  closeCandidateInfo() {
    this.viewingCandidate = null;
  }

  // -------------------------------------------------------------------
  public trackByDocumentId(index: number, doc: Document): Document['id'] {
    return doc.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  backgroundImg() {
    return 'url(' + this.img_empty + ')';
  }

  /*
  // -------------------------------------------------------------------
  save(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.profileService.queryMyProfile(32).subscribe(res => {
      console.warn('PING');
      onsuccess();
    });
  }
  */
}
